import { ListPillItem, PillItem } from "@search/api/types";
import { FilterSet } from "@search/store/FilterSet";
import type { Filters, SearchStore } from "@search/store/types";
import { buildFilters } from "@search/store/utils";
import { createStore } from "zustand/vanilla";

export const createSearchStore = (query: string) => {
  return createStore<SearchStore>()((set, get) => ({
    ...{ filters: buildFilters(query) },

    filterSet: (): FilterSet => new FilterSet(get().filters),

    getPills: (): Array<ListPillItem | PillItem> =>
      get().filterSet().getPills(),

    getQuery: (): string => get().filterSet().buildURLParams(),

    updateFilter: (newFilters: Partial<Filters>) => {
      const filterSet = get().filterSet();

      if (Object.keys(newFilters).length > 0) {
        set({ filters: filterSet.update(newFilters) });
      } else {
        set({ filters: buildFilters("") });
      }
    },

    updateFilterFromQuery: (queryString: string) => {
      set({ filters: buildFilters(queryString) });
    },
  }));
};
